import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types';
import { Form, Input, Button, Checkbox } from 'antd';
import { useDispatch, useSelector } from "react-redux";
import { saveForm, changevalueForm , getSeguimientoID} from '../actions/saveForm';


function Formulario(props) {
	const dispatch = useDispatch();
	const [comentariosnew, setComen] = useState('')

	const onSaveForm = (e) => {
		e.preventDefault();
		dispatch(saveForm())
		setComen('');
		dispatch(getSeguimientoID("idseguimiento", props.idkey))

	}
	
    const  onChangeValue  = (e) => {
		setComen(e.target.value);
		dispatch(changevalueForm("comentarios",e.target.value));
		dispatch(changevalueForm("idos", props.idkey))
	}

    return (
        <div>
            <Form
			initialValues={{ comentarios: comentariosnew }}
			labelCol={{ span: 8 }}
			wrapperCol={{ span: 16 }}
			>
			
				<Form.Item
				    label="Comentarios"
				    name="comentarios"
					value={comentariosnew}
					onChange={ onChangeValue }
				    rules={[{ required: true, message: 'Ingresa un comentario' }]}>
				    <Input.TextArea
			            placeholder=""
					/>
				</Form.Item>
		
				<Form.Item  wrapperCol={{ offset: 8, span: 16 }} >
					<Button type="primary"   onClick={onSaveForm} >
						Guardar
		          </Button>  
				</Form.Item>

			</Form>
        </div>
        
    );
}

export default Formulario;


  
  
  
